import { mapGetters, mapActions } from 'vuex'

import PublicPageWrapper from '@/components/PublicPageWrapper/index'
import MainButton from '@/components/MainButton/index'
import { setTimeout } from 'timers'

export default {
  name: 'VerifyEmail',
  components: {
    PublicPageWrapper,
    MainButton
  },
  data: () => ({
    emailToken: null,
    responseText: 'Verifying...',
    emailVerifySuccess: true
  }),
  computed: {
    ...mapGetters('verifyEmail', {
      emailVerifyResponse: 'EMAIL_VERIFICATION_RESPONSE'
    })
  },
  methods: {
    ...mapActions('verifyEmail', {
      verifyEmailAction: 'VERIFY_EMAIL'
    })
  },
  beforeCreate() {
    if (!this.$route.query.token) {
      this.$router.push({ name: 'login' })
    }
  },
  created() {
    this.emailToken = this.$route.query.token

    this.verifyEmailAction({ token: this.emailToken }).then(() => {
      const { message, success } = this.emailVerifyResponse
      this.emailVerifySuccess = success

      if (success) {
        this.responseText = message
        setTimeout(() => {
          this.$router.push({ name: 'login' })
        }, 5000)
      } else {
        this.responseText = ''
      }
    })
  }
}
